/**
 * Base
 */
import A11yDialog from "a11y-dialog";

/**
 * Custom
 */
import modalBulkGiftCard from './modal/bulk-giftcard.js';

/**
 * Map custom modals by id + var
 */
var customModal = {
  "modal-bulk-giftcard": modalBulkGiftCard,
};

/**
 * Global body class handling for ANY a11y-dialog instance.
 *
 * a11y-dialog's `fire()` dispatches its "show"/"hide" CustomEvents WITHOUT
 * `bubbles: true`, so a normal (bubble-phase) delegated listener on
 * document never sees them. Capture-phase listeners still work, because
 * the capture phase runs top-down (document → target) regardless of
 * whether the event bubbles — so we register with `capture: true`.
 */
function isAnyDialogOpen() {
  return !!document.querySelector(
    '[data-a11y-dialog]:not([aria-hidden="true"])',
  );
}

document.addEventListener(
  "show",
  function (event) {
    if (!event.target.matches("[data-a11y-dialog]")) return;
    document.body.classList.add("dialog-open");
  },
  true, // capture
);

document.addEventListener(
  "hide",
  function (event) {
    if (!event.target.matches("[data-a11y-dialog]")) return;
    if (!isAnyDialogOpen()) {
      document.body.classList.remove("dialog-open");
    }
  },
  true, // capture
);

/**
 * Init
 */
document.querySelectorAll("[data-a11y-dialog]").forEach(function (el) {
  if (customModal[el.id]) {
    customModal[el.id].init();
    console.log("Init: " + el.id);
  } else {
    new A11yDialog(el);
  }
});

document.addEventListener("click", function (event) {
    var trigger = event.target.closest('[data-a11y-dialog-show="modal-exit-site"]');

    if (!trigger) return;

    var targetUrl = trigger.getAttribute("data-target-url");

    if (!targetUrl) return;

    var continueButton = document.querySelector(
        "#modal-exit-site .js-exit-site-continue"
    );

    if (continueButton) {
        continueButton.setAttribute("href", targetUrl);
    }
});
